import { render } from "./Company.vue?vue&type=template&id=3a0fde07"
import script from "./Company.vue?vue&type=script&lang=js"
export * from "./Company.vue?vue&type=script&lang=js"
script.render = render

export default script